module.exports = __webpack_public_path__ + "static/media/color.36386c0a.png";